import Button from "../Button/Button";
import {IItem} from "../ListBox/ListItem";
import Menu, {MenuItemArgs} from "../Menu/Menu";
import Delegate from "../../Delegate";
import ListItemCheckBox from "../ListBox/ListItemCheckBox";

export default class MenuButton extends Button {
	private _Items: IItem[];
	private _Text: string;
	private EvChanged: Delegate;
	private EvItemClicked: Delegate;


	constructor(settings?: object)
	{
		super(settings);
	}

	_initFields(settings: object)
	{
		this.EvItemClicked = new Delegate();
		this.EvChanged = new Delegate();
		this._Text = "";
		this._Items = []
		super._initFields(settings);
		this._Content = this._Text;
		this._Items.forEach(item => item.IsCheckBox = true)

		this._Menu = new Menu({
			Items: this._Items,
			EvItemSelected: (s: object, e: MenuItemArgs) =>
			{
				if (e.Item instanceof ListItemCheckBox)
				{
					e.IsCancelClose = true;
					e.Item.setIsChecked(!e.Item.getIsChecked());
					this.setContent(this._Text + " " + this.getMenu().getSelectedValues().length)
				}
				else
					this.EvItemClicked.fire(this, e)
			},
			EvClosed: () =>
			{
				let newValues = this.getMenu().getSelectedValues()
				if (!this.compareArrays(newValues, this._Value))
				{
					this._Value = newValues;
					this.EvChanged.fire(this)
				}
			}
		});
		this._Width = 200;
	}

	compareArrays(arr1: any[], arr2: any[])
	{
		if (arr1.length != arr2.length)
			return false;

		for (let a1 of arr1)
		{
			if (arr2.indexOf(a1) == -1)
				return false;
		}

		return true;
	}

	getValue(): any[]
	{
		return this._Menu.getSelectedValues();
	}

	setValue(value: any[])
	{
		this.getMenu().getItems().forEach(item =>
		{
			if (item.setIsChecked)
				item.setIsChecked(value.indexOf(item.getValue()) > -1);
		})
		this._Value = value;

		this.setContent(this._Text + " " + this._Value.length)
	}

	_render(tag: string = 'button')
	{
		super._render(tag);
		this.addClass('app-button--raised')
	}
}